import React from 'react'
import { formatCashAmount } from '../../../lib/utils'
import CoupureIcon from './CoupureIcon'

type Props = {
    cn: 'c' | 'n',
    coupures: CoupureInputForeignCurrency[],
    currency?: string,
    show_total?: boolean,
    show_mutated?: boolean

    deviesCurrency?: DeviesCurrency
}

const CoupureForeignCurrency : React.FC<Props> = ({cn, coupures, currency='EUR', show_total=false, show_mutated=false, deviesCurrency}) => {

    let amountCols = 2;
    if(show_total) { amountCols++ }
    if(show_mutated) { amountCols++ }

    if(deviesCurrency){

        const c_devies = deviesCurrency.devies.filter(i=>i.cn.toLowerCase() === 'c')
        const n_devies = deviesCurrency.devies.filter(i=>i.cn.toLowerCase() === 'n')

        return (
            <>
                {cn === 'c' &&
                <>
                    {c_devies.map((devies) => (
                        <div className={`grid grid-cols-${amountCols}`} key={`devies-coin-${devies.value}`}>
                            <div className='flex items-center gap-2'>
                                <CoupureIcon cn='c' value={devies.value} />
                                <p>{devies.value} {deviesCurrency.deviescurrencyactive}</p>
                            </div>
                            <div className='flex items-center justify-end'><p className='font-semibold'>{coupures.find(coupure => Number(coupure.coupure) === devies.value)?.qty || 0}</p></div>
                            {show_mutated && <div className='flex items-center justify-end'><p className='font-semibold'>{coupures.find((i)=>Number(i.coupure) === devies.value)?.qty_mut || 0}</p></div>}
                            {show_total && <div className='flex items-center justify-end'><p className='font-semibold'>{formatCashAmount(((coupures.find((i)=>Number(i.coupure) === devies.value)?.qty || 0)+(coupures.find((i)=>Number(i.coupure) === devies.value)?.qty_mut || 0))*devies.value)}</p></div>}
                        </div>
                    ))}
                </>
                }

                {cn === 'n' &&
                <>
                    {n_devies.map((devies) => (
                        <div className={`grid grid-cols-${amountCols}`} key={`devies-note-${devies.value}`}>
                            <div className='flex items-center gap-2'>
                                <CoupureIcon cn='n' value={devies.value} />
                                <p>{devies.value} {deviesCurrency.deviescurrencyactive}</p>
                            </div>
                            <div className='flex items-center justify-end'><p className='font-semibold'>{coupures.find(coupure => Number(coupure.coupure) === devies.value)?.qty || 0}</p></div>
                            {show_mutated && <div className='flex items-center justify-end'><p className='font-semibold'>{coupures.find((i)=>Number(i.coupure) === devies.value)?.qty_mut || 0}</p></div>}
                            {show_total && <div className='flex items-center justify-end'><p className='font-semibold'>{formatCashAmount(((coupures.find((i)=>Number(i.coupure) === devies.value)?.qty || 0)+(coupures.find((i)=>Number(i.coupure) === devies.value)?.qty_mut || 0))*devies.value)}</p></div>}
                        </div>
                    ))}
                </>
                }
            </>
        )
    }
    

  return (
    <>
    </>
  )
}

export default CoupureForeignCurrency